import { ThunkType } from "../../../../core/store/reducers";
import { getPaymentsExcel } from "../api/getPaymentsExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../paymentsDataSlice";

export const downloadPaymentsExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }
  
  const { filter } = store.ux.clearing.payments;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getPaymentsExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "Payments.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
